class QuickBuyCarousel extends HTMLElement {
  constructor() {
    super();
    this.isDown = false;
    this.startX = 0;
    this.scrollLeft = 0;

    this.isMobile = window.matchMedia('(max-width: 740px)').matches;
  }

  connectedCallback() {
    if (this.isMobile) return

    this.addEventListener('mousedown', this.onMouseDown.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.addEventListener('mouseup', this.onMouseUp.bind(this));
    this.addEventListener('mousemove', this.onMouseMove.bind(this));

    this.addEventListener('touchstart', this.onTouchStart.bind(this), {
      passive: true,
    });
    this.addEventListener('touchend', this.onTouchEnd.bind(this));
    this.addEventListener('touchmove', this.onTouchMove.bind(this), {
      passive: false,
    });
  }

  onMouseDown(e) {
    this.isDown = true;
    this.classList.add('dragging');
    this.startX = e.pageX;
    this.scrollLeftStart = this.scrollLeft;
  }

  onMouseLeave() {
    this.isDown = false;
    this.classList.remove('dragging');
  }

  onMouseUp() {
    setTimeout(() => {
      this.dragged = false;
    }, 0);

    this.isDown = false;
    this.classList.remove('dragging');
  }

  onMouseMove(e) {
    if (!this.isDown) return;

    const x = e.pageX;

    if (Math.abs(x - this.startX) > 5) {
      this.dragged = true;
    }
    const walk = (x - this.startX);
    this.scrollLeft = this.scrollLeftStart - walk;
  }

  onTouchStart(e) {
    setTimeout(() => { this.dragged = false }, 0);
    this.isDown = true;
    this.startX = e.touches[0].pageX - this.offsetLeft;
    this.scrollLeft = this.scrollLeft;
  }

  onTouchEnd() {
    this.isDown = false;
  }

  onTouchMove(e) {
    if (!this.isDown) return;
    const x = e.touches[0].pageX - this.offsetLeft;
    const walk = (x - this.startX) * 1.5;
    this.scrollLeft -= walk;
    this.startX = x;
    e.preventDefault();
  }
}

if (!customElements.get('quick-buy-carousel')) {
  customElements.define('quick-buy-carousel', QuickBuyCarousel);
}
